import React from "react";
import ADHDAssistantContainer from "./ADHDAssistantContainer";

export interface ADHDAssistantProps {
  videoRef?: React.RefObject<HTMLVideoElement>;
  videoStream?: MediaStream | null;
  onVideoStreamChange?: (stream: MediaStream | null) => void;
  onNavigateToSettings?: () => void;
  onNavigateToAnalytics?: () => void;
}

/**
 * ADHD Assistant - Refactored from monolithic component to use container/component pattern
 *
 * This component now delegates all logic to ADHDAssistantContainer which uses:
 * - useADHDData hook for state management
 * - useOverwhelm hook for overwhelm detection
 * - useToolCalls hook for AI function call processing
 * - FunctionCallProcessor service for business logic
 * - ADHDAssistantContent for UI rendering
 */
const ADHDAssistant = React.memo<ADHDAssistantProps>(props => {
  return <ADHDAssistantContainer {...props} />;
});

ADHDAssistant.displayName = "ADHDAssistant";

export default ADHDAssistant;
